import { object } from 'prop-types'
import { forwardRef } from 'react'
import Image from '../../particles/image'
import { CardTextStyled } from './card-image.styled'
import CardText from './card-text'

const CardImage = forwardRef(({ image, ...props }, ref) => {
	// eslint-disable-next-line jsx-a11y/alt-text
	return <CardTextStyled ref={ref} {...props} header={<Image {...image} />} />
})

CardImage.displayName = 'CardImage'

CardImage.defaultProps = { ...CardText.defaultProps }

CardImage.propTypes = {
	...CardText.propTypes,
	image: object.isRequired,
}

export default CardImage
